export default "__VITE_PUBLIC_ASSET__61f0ee93__"